import { render, staticRenderFns } from "./IconAngle.vue?vue&type=template&id=53f32f86&scoped=true&"
var script = {}
import style0 from "./IconAngle.vue?vue&type=style&index=0&id=53f32f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f32f86",
  null
  
)

export default component.exports